// extracted by mini-css-extract-plugin
export default {"knowAbout":"Occassion_knowAbout__3Sjc7","knowAbout__ul":"Occassion_knowAbout__ul__gUKPu","knowAbout__ul__li":"Occassion_knowAbout__ul__li__Hh-LV"};